// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { Link2 as RawLink2 } from "lucide-react";
export const Link2 = /* @__PURE__ */ createIcon(RawLink2, "Link2", 2);
